import { Type } from '@angular/core';
import { ItemsListHeadItemLabelComponent } from './head-item/head-item-label/head-item-label.component';
import { ReplaySubject } from 'rxjs';
import { IItemsListAction } from '@fi-app/components/items-list/items-list';

export class ItemsListHeader {
    Label: string;
    PropertyName: string;
    Properties: ItemsListHeaderProperties;
    ChildPropertyName: string;
    ChildProperties;
    DisplayPropertyName;

    constructor(
        label: string,
        propertyName: string,
        properties: ItemsListHeaderProperties,
        childPropertyName?: string,
        childProperties?,
        displayPropertyName?: string | ((data, propertyName: string, parentData?) => any),
    ) {
        this.Label = label;
        this.PropertyName = propertyName;
        this.Properties = properties;
        this.ChildPropertyName = childPropertyName;
        this.ChildProperties = childProperties;
        this.DisplayPropertyName = displayPropertyName;
    }
}

export class ItemsListHeaderProperties {
    Class: string;
    IsSortable: boolean;
    ElementType: any;
    ExtraProperties: IExtraProperties;
    updateContent$ = new ReplaySubject<void>(1);

    constructor(cl: string, isSortable: boolean, elementType: any, extraProperties?: IExtraProperties) {
        this.Class = cl;
        this.IsSortable = isSortable != undefined ? isSortable : false;
        this.ElementType = elementType;
        this.ExtraProperties = extraProperties;
    }
}

export interface IExtraProperties {
    Sref?: string | ((row?) => string);
    SrefParams?: any;
    secondaryValue?: (data) => any; // show secondary value in ItemsListRowItemDisplayValueComponent
    secondaryValueClass?: string; // add class to secondary value in ItemsListRowItemDisplayValueComponent
    ImgSrc?: string | ((data) => string);
    ImgSrcLarge?: string | ((data) => string);
    mobileSubText?: (data) => any;
    GetClass?: (data) => any;
    RowItemClass?: string; // add class to row item, now implemented in ItemsListRowItemAComponent
    getMainValueClass?: (data) => string; // add class to main value in ItemsListRowItemDisplayValueComponent
    getBadge?: (data) => any; // show badge after main value in ItemsListRowItemDisplayValueComponent
    headLabelType?: Type<ItemsListHeadItemLabelComponent>;
    headData?: any;
    target?: string;
    actions?: Array<IItemsListAction<any>>;
    onClick?: ($event: MouseEvent, data, parentData) => void;
    isRightAligned?: boolean;
    smallRightPadding?: boolean;
    useParentDataForDisplay?: boolean;
}

export const ItemsListElementType = {
    A: 'a',
    ArrayA: 'arrayA',
    ArraySpan: 'arraySpan',
    Img: 'img',
    ImgIcon: 'imgIcon',
    ImgIconA: 'imgIconA',
    Email: 'email',
    Tel: 'tel',
    IconA: 'iconA',
    AChild: 'aChild',
    Tags: 'tags',
    DateTime: 'datetime',
    Actions: 'actions',
    Icon: 'icon',
    SpanPlain: 'spanplain',
    SpanChildA: 'spanchilda',
};
